import { render, staticRenderFns } from "./AuthGuard.vue?vue&type=template&id=8b557db4&scoped=true&"
import script from "./AuthGuard.vue?vue&type=script&lang=js&"
export * from "./AuthGuard.vue?vue&type=script&lang=js&"
import style0 from "./AuthGuard.vue?vue&type=style&index=0&id=8b557db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b557db4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b557db4')) {
      api.createRecord('8b557db4', component.options)
    } else {
      api.reload('8b557db4', component.options)
    }
    module.hot.accept("./AuthGuard.vue?vue&type=template&id=8b557db4&scoped=true&", function () {
      api.rerender('8b557db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/AuthGuard.vue"
export default component.exports